<template>
<div>
    <div class="header">
        <div class="search">
            <img :src="Images.icon_search" alt="">
            <input type="text" placeholder="请输入学员姓名或手机号搜索" v-model="keyword">
            <div></div>
            <p>查询</p>
        </div>
    </div>
    <div class="screen" @click="showPopup">
        <p>{{tab.value}}</p>
        <img :src="Images.icon_screen" alt="">
    </div>
    <div class="scrollerView" :style="{ height: (wrapperHeight- 125) + 'px' }">
        <scroller :on-refresh="_onRefresh" :on-infinite="_onEndReached" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
            <inheritorItem v-for="(item, index) in dataSources" :key="index" :item="item" />
            <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
        </scroller>
    </div>
    <van-popup v-model="show" position="bottom">
        <div class="popup-window">
            <div v-for="(item, index) in tabSource" :key="index" @click="onPressTab(item)">{{item.value}}</div>
        </div>
    </van-popup>
</div>
</template>

<script>
import Header from '@/components/Header'
import inheritorItem from '@/components/item/inheritorItem'
import lecturerItem from '@/components/item/lecturerItem'
export default {
    components: {
        Header,
        lecturerItem,
        inheritorItem,
    },
    data() {
        return {
            loading: false,
            show: false,
            user_type: this.$route.query.user_type || this.Constants.USER_MASTER,
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 0,
            limit: 10,
            keyword: '',
            tab: {},
            tabSource: [],
            dataSources: [],
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.requestTabDataSource();
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if (!url) return;
            window.location.href = url;
        },

        // 显示弹窗
        showPopup() {
            this.show = !this.show
        },

        // 点击tab 
        onPressTab(item) {
            this.tab = item;
            this.show = !this.show
            this._onRefresh();
        },

        async requestTabDataSource() {
            let url = this.API.agent_my_team_search;
            let params = {
                user_type: this.user_type,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.tabSource = result.data.list;
                this.tab = result.data.list[0];
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        async _requestDataSources() {
            let url = this.API.agent_my_team;
            let data = {
                page: this.page,
                limit: this.limit,
                tab: this.tab.title,
                keyword: this.keyword,
                user_type: this.user_type,
            };
            try {
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.dataSources.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.dataSources = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                this._onStopLoading(true);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log('status---->', status);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: calc(100% - 30px);
    margin: 0px 15px 0;
    box-sizing: border-box;
}

.scroller {
    background: #fff;
    box-sizing: border-box;
}

.header {
    position: relative;
    height: 60px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;

    .left-btn {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
            display: block;
            height: 20px;
            opacity: .8;
        }
    }

    .search {
        flex: 1;
        padding: 0 10px;
        // margin-left: 30px;
        height: 34px;
        display: flex;
        align-items: center;
        background: #F5F5F5;
        border-radius: 5px;

        img {
            width: 14px;
            height: 14px;
        }

        input {
            flex: 1;
            margin: 0 10px;
            font-size: 12px;
            color: #333
        }

        div {
            width: 1px;
            height: 15px;
            background: #999;
        }

        ::-webkit-input-placeholder {
            color: #999
        }

        p {
            padding: 0 0 0 10px;
            font-size: 14px;
            color: #666;
        }
    }
}

.screen {
    padding: 0 15px;
    margin-bottom: 10px;
    height: 40px;
    display: flex;
    align-items: center;
    background: #fff;

    p {
        flex: 1;
        font-size: 15px;
        color: #7181EB;
    }

    img {
        width: 10px;
        height: 15px;
        object-fit: contain;
    }
}

.popup-window {
    max-height: 525px;
    overflow: scroll;

    >div {
        padding: 0 15px;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #e1e1e1;
        font-size: 15px;
        color: #333;
    }
}
</style>
